import { IconMoodCry } from '@tabler/icons-preact';

import css from './Problem.module.css';

export const Problem = () => {
  return (
    <div class={css.root}>
      <IconMoodCry class={css.icon} />
      <p class={css.message}>
        Oops!
        <br />
        Something went wrong.
      </p>
    </div>
  );
};
